import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Accordion } from 'react-bootstrap';
import { isArray } from 'lodash';
import appConfig from '../../appConfig';
import { showMetaEditTool } from '../../utils/uiUtils';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

const getDisplayName = (groupName) => {
  let displayGroupName = groupName;
  if (appConfig.setSchemaName) {
    if (appConfig.setSchemaName.schemaName &&
      appConfig.setSchemaName.schemaName.toUpperCase() === groupName.toUpperCase()) {
      displayGroupName = appConfig.setSchemaName.displayTitle;
    } else if (isArray(appConfig.setSchemaName)) {
      const cur = appConfig.setSchemaName.find(
        (item) => item.schemaName.toUpperCase() === groupName.toUpperCase()
      );
      if (cur) displayGroupName = cur.displayTitle;
    }
  }
  return displayGroupName;
};

function MetadataViewGroup({ metaItems, umoID, toggleUMODetailView, umo }) {
  const metaGroup = [];
  const metaGroupComponent = [];
  const dispatch = useDispatch();
  const defaultExpandedGroups = useMemo(() => {
    if (appConfig.autoExpandMetaSchema) {
      return (isArray(appConfig.autoExpandMetaSchema) ? appConfig.autoExpandMetaSchema :
      [appConfig.autoExpandMetaSchema]).map(group => group.toUpperCase());
    }
  }, []);
  const [expandedGroups, setExpandedGroups] = useState(new Set(defaultExpandedGroups));

  for (let i = 0; i < metaItems.length; i++) {
    const groupName = metaItems[i].props.metadata.category;
    if (metaGroup.indexOf(groupName) < 0) metaGroup.push(groupName);
  }

  const isAnyMetadataEditable = (metaGroupTags) => {
    return metaGroupTags.some((tagGroup) =>
      Object.values(tagGroup?.props?.metadata).some(
        (entry) => entry?.$?.ctie === 'T'
      )
    );
  };

  const onMetaEditClick = (metaGroup) => {
    showMetaEditTool(umo, dispatch, metaGroup);
    toggleUMODetailView(false);
  };
  const onExpand = (umoID, metaGroup) => {
    $(`div[id='${umoID}_${metaGroup}_collapse']`).toggle();
    setExpandedGroups((prev) => {
      const next = new Set(prev);
      next.has(metaGroup) ? next.delete(metaGroup) : next.add(metaGroup);
      return next;
    });
  };
  for (let i = 0; i < metaGroup.length; i++) {
    let grpStyle;
    const isExpanded = expandedGroups.has(metaGroup[i]);
    grpStyle = isExpanded ? { display: 'block' } : { display: 'none' };


    const metaGroupTags = [];
    for (let k = 0; k < metaItems.length; k++) {
      if (metaItems[k].props.metadata.category === metaGroup[i])
        metaGroupTags.push(metaItems[k]);
    }

    metaGroupComponent.push(
      <div
        key={`group_${metaGroup[i]}`}
        className="umo-detail-view__meta-group card card-default"
      >
        <div
          className="umo-detail-view__meta-group-heading card-header"
          role="tab"
        >
          <div role="button" onClick={() => onExpand(umoID, metaGroup[i])}>
            <div className="umo-detail-view__meta-group-title card-title font-md-regular">
              <i
                className={classNames('fa', 'pr-2', {
                  'fa-minus': isExpanded,
                  'fa-plus': !isExpanded,
                })}
              />
              {getDisplayName(metaGroup[i])}
              {appConfig.allowIndividualMetaEdit &&
                isAnyMetadataEditable(metaGroupTags) && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onMetaEditClick(metaGroup[i]);
                    }}
                    className="umo-detail-view__edit-meta-button"
                  >
                    <i className="umo-detail-view__edit-meta-icon" />
                  </button>
                )}
            </div>
          </div>
        </div>
        <div
          id={`${umoID}_${metaGroup[i]}_collapse`}
          className="card-collapse collapse"
          role="tabpanel"
          style={grpStyle}
        >
          <div className="umo-detail-view__meta-group-body card-body">
            {metaGroupTags}
          </div>
        </div>
      </div>
    );
  }

  return <Accordion>{metaGroupComponent}</Accordion>;
}

MetadataViewGroup.propTypes = {
  metaItems: PropTypes.instanceOf(Array),
  umoID: PropTypes.string,
};

export default MetadataViewGroup;
